import { render, staticRenderFns } from "./partners-categories-view.vue?vue&type=template&id=fb56eb68&"
import script from "./partners-categories-view.vue?vue&type=script&lang=js&"
export * from "./partners-categories-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports